import { ErrorAlert } from "@components/ErrorAlert";
import { queriesWorksites } from "@query";
import {
  useWSModalCustom,
  WSForm,
  WSList,
  WSModal,
  WSModalCustomProps
} from "@wingspanhq/fe-component-library";
import { Worksite } from "@wingspanhq/wingspan-api-sdk";
import React from "react";

import { FormPartialWorksite } from "../../components/FormPartialWorksite";
import { selectorWorksiteFormDefaultValues } from "../../selectors/selectorWorksiteFormDefaultValues";
import { selectorWorksiteRequest } from "../../selectors/selectorWorksiteRequest";
import { FormDataWorksite } from "../../types";
import { validationSchemaWorksite } from "../../validationSchemaWorksite";

type Props = {
  worksite: Worksite;
} & WSModalCustomProps<Worksite | null>;

const ModalEditWorksite: React.FC<Props> = props => {
  const [updateWorksite, meta] = queriesWorksites.updateWorksite.useMutation();

  const handleSubmit = async (formData: FormDataWorksite) => {
    if (!props.worksite.id) {
      return;
    }

    await updateWorksite(
      {
        worksiteId: props.worksite.id,
        worksiteUpdate: selectorWorksiteRequest(formData)
      },
      { onSuccess: updated => props.onClose(updated) }
    );
  };

  return (
    <WSForm<FormDataWorksite>
      defaultValues={selectorWorksiteFormDefaultValues(props.worksite)}
      validationSchema={validationSchemaWorksite}
      onSubmit={handleSubmit}
    >
      <WSModal
        size="S"
        title="Edit work site"
        onClose={() => props.onClose(null)}
        actions={{
          buttons: [
            {
              label: "Cancel",
              kind: "Secondary",
              type: "button",
              onClick: () => props.onClose(null)
            },
            {
              label: "Save updates",
              type: "submit",
              loading: meta.isLoading
            }
          ]
        }}
      >
        <WSList gap="L">
          <FormPartialWorksite />
          <ErrorAlert context="WorksiteSave" error={meta.error} />
        </WSList>
      </WSModal>
    </WSForm>
  );
};

export const useModalEditWorksite = () => useWSModalCustom(ModalEditWorksite);
